<template>
	<div class="lists" v-if="list.length">
		<div class="lists_item" v-for="(item, index) in list" v-if="index>0" :key="index" @click="goDetail(item.id,1)">
			<div class="titles">
				<span class="point"></span>
				<span class="text line-1">{{ item.title || '-' }}</span>
			</div>
			<div class="time" v-if="hasTime">{{ changeTime(item.pub_time) || changeTime(item.addtime) || '' }}</div>
		</div>
	</div>
	<el-empty class="nodata" description="暂无数据" v-else></el-empty>
</template>

<script>
	export default {
		props: {
			list: {
				type: [Array, Number],
				default: []
			},
			hasTime: {
				type: Boolean,
				default: true
			}
		},
		methods: {
			// 查看详情
			goDetail(id,flag) {
				this.$emit("goDetail",id,flag)
			}
		},
	}

</script>

<style lang="scss" scoped>
.lists{
	width: 100%;
}
	.lists_item{
		margin-top: .8rem;
		padding: 0.625rem 0;
		box-sizing: border-box;
		width: 100%;
		cursor: pointer;
		display: flex;
		justify-content: space-between;
		align-items: center;
		.titles{
			width: 100%;
			flex: 1;
			display: flex;
			align-items: center;
			.point{
				height: 0.5rem;
				width: 0.5rem;
				background-color: #E44100;
				border-radius: 50%;
				margin-right: 1rem;
			}
			.text{
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				width: 100%;
				flex: 1;
				font-size: 1.25rem;
				color: #000;
			}
		}
		.time{
			width: 5.5625rem;
			margin-left: 0.3125rem;
			color: #9e9e9e;
			font-size: 1rem;
		}
		&:hover{
			background-color: #FFF9F9;
			.titles{
				.text{
					color: #B80000;
					font-weight: bold;
				}
			}
		}
	}
</style>